import { Input, Component } from '@angular/core';

import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent {
  @Input() message: string;
  @Input() displayButton: boolean;
  @Input() buttonText: string;

  icon = AppIcon;

  constructor(private readonly modalController: FrontendModalService) {}

  close(): void {
    this.modalController.dismiss();
  }

  closedWithButtonClick(): void {
    this.modalController.dismiss(true);
  }
}
